import React, { memo, useContext } from "react";
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";
import { SelectBoxContext } from "components/selectBox/SelectBoxContext";

import SelectBoxSearch from "components/selectBox/SelectBoxSearch";
import SelectBoxZone from "components/selectBox/SelectBoxZone";

import "css/admin/utils/select-box.scss";
import "css/admin/admin.scss";

function SelectBoxPanel({ hasRank, title, tabs, selected, t }) {
  const context = useContext(SelectBoxContext);

  return (
    <div className="selectbox-panel">
      <div className="editor-select-box-panel-title">{title}</div>
      <div className="editor-select-box-panel-informations">
        <p>
          {t("elementsCount", {
            count: selected
              ? context.selectedFilteredItems.length
              : context.libraryFilteredItems.length,
          })}
        </p>
      </div>

      <SelectBoxSearch
        searchText={selected ? context.selectedSearch : context.librarySearch}
        onChangeSearch={
          selected ? context.setSelectedSearch : context.setLibrarySearch
        }
      />
      <SelectBoxZone hasRank={hasRank} tabs={tabs} selected={selected} />
    </div>
  );
}

SelectBoxPanel.propTypes = {
  hasRank: PropTypes.bool,
  title: PropTypes.string,
  selected: PropTypes.bool,
  t: PropTypes.func.isRequired,
  tabs: PropTypes.array,
};

export default withTranslation("editor-utils")(memo(SelectBoxPanel));
